<template>
    <div>
        This is the orders page
    </div>
</template>